import { useFetchUserStatusQuery } from '@/api/user-api'
import { CountryCode } from '@/constants/country-code'

const useIsJapan = (): boolean => {
  const { data: userStatus } = useFetchUserStatusQuery()
  return userStatus?.currentWorkspace.countryCode === CountryCode.JP
}

export default useIsJapan
